(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7463,7477,7057],{

/***/ 48664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83157);
/* harmony import */ var _styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31555);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);







const BenefitsOfAttendaAdmissionDay = ({ benefitdata  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            id: "benefits-attend",
            className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_3___default().benefitsAttend),
            style: {
                backgroundColor: benefitdata?.sectionBgColor || "#fff"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_3___default().maindiv),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_3___default().heading),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: benefitdata?.sectionTitle
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            children: benefitdata?.pointImage?.length > 0 && benefitdata?.pointImage?.map((pointImages)=>{
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    xl: 6,
                                    lg: 6,
                                    md: 6,
                                    sm: 12,
                                    xs: 6,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_3___default().mainBox),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_3___default().box),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_3___default().img),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                        src: pointImages?.imageUrl,
                                                        width: 30,
                                                        height: 30,
                                                        className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_3___default().studImg),
                                                        alt: "handshake.png"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_3___default().para),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: pointImages?.title
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                });
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BenefitsOfAttendaAdmissionDay);


/***/ }),

/***/ 26102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83157);
/* harmony import */ var _styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31555);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54076);










const StudiesFAQ = ({ faqdata  })=>{
    const sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const settings = {
        infinite: true,
        arrows: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 3,
        rows: 3,
        slidesPerRow: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 3,
                    arrows: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 3,
                    dotsClass: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sliderDots),
                    dots: true
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default().studyquas),
            style: {
                backgroundColor: faqdata?.sectionBgColor || "#EFEFFA"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default().heading),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: faqdata?.sectionTitle
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default().popularCourseslider),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    ...settings,
                                    className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default().slider),
                                    ref: sliderRef,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            children: faqdata?.questions?.length > 0 && faqdata?.questions?.map((faqsdata)=>{
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                    xl: 6,
                                                    lg: 6,
                                                    md: 6,
                                                    sm: 12,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                        defaultActiveKey: "0",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Item */ .Z.Item, {
                                                            className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default().stuAccordion),
                                                            eventKey: "1",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Header */ .Z.Header, {
                                                                    className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accoHead),
                                                                    children: faqsdata?.question
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Body */ .Z.Body, {
                                                                    className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accorBody),
                                                                    children: faqsdata?.answer
                                                                })
                                                            ]
                                                        })
                                                    })
                                                });
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (StudiesFAQ);


/***/ }),

/***/ 67962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83157);
/* harmony import */ var _styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35005);
/* harmony import */ var _hooks_useZipmeLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98196);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32866);











const WhyStudyCountry = ({ whystudydata , jotformId , externalLink  })=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const { zipmeLink , generateLink  } = (0,_hooks_useZipmeLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().studentSpecialOffer),
            style: {
                backgroundColor: whystudydata?.sectionBgColor || "#EFEFFA"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().row),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            xl: 7,
                            lg: 7,
                            md: 12,
                            sm: 12,
                            className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().stuImgtextd),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().heading),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        children: whystudydata?.sectionTitle
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: whystudydata?.sectionDesc
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().heading),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        children: whystudydata?.sectionFactsTitle
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().OffersContent),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                        className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().ulliQuick),
                                        children: whystudydata?.quickFacts?.length > 0 ? whystudydata.quickFacts.length > 0 && whystudydata.quickFacts.map((quickFact, ind)=>{
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().ulliQuickli),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().quickImg),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                            src: quickFact?.imageUrl || "/images/admissionsday/popularstart.png",
                                                            width: 35,
                                                            height: 35,
                                                            className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().cardImg),
                                                            alt: "alttag"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                        children: [
                                                            " ",
                                                            quickFact.title
                                                        ]
                                                    })
                                                ]
                                            }, ind);
                                        }) : whystudydata?.sectionFacts?.length > 0 && whystudydata.sectionFacts.map((offer, ind)=>{
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                children: offer
                                            }, ind);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().anchor),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        onClick: ()=>{
                                            !jotformId && generateLink(externalLink);
                                        },
                                        className: `${(_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btnReg)} ${jotformId ? `${(0,_utils_helpers__WEBPACK_IMPORTED_MODULE_5__/* .isFrappeOrJotFormClass */ .gd)(jotformId)}` : ""}`,
                                        children: router.asPath.includes("/company/") ? "Register Now" : "Enquire Now"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            xl: 5,
                            lg: 5,
                            md: 12,
                            sm: 12,
                            className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().stuImgd),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().studyServSection),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().platformDivImg),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().pica),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                src: whystudydata?.sectionImages[0]?.imageUrl || "/cana_a.svg",
                                                width: 200,
                                                height: 200,
                                                alt: "cana_a.svg",
                                                objectFit: "fill"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().picb),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                src: whystudydata?.sectionImages[1]?.imageUrl || "/cana_b.svg",
                                                width: 200,
                                                height: 280,
                                                alt: "cana_b.svg",
                                                objectFit: "fill"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().picc),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                src: whystudydata?.sectionImages[2]?.imageUrl || "/cana_c.svg",
                                                width: 200,
                                                height: 280,
                                                alt: "cana_c.svg",
                                                objectFit: "fill"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().picd),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                src: whystudydata?.sectionImages[3]?.imageUrl || "/cana_d.svg",
                                                width: 200,
                                                height: 200,
                                                alt: "cana_d.svg",
                                                objectFit: "fill"
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WhyStudyCountry);


/***/ }),

/***/ 70710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LazyReveal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
"use client";


const DefaultShimmer = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "animate-pulse bg-gray-300 h-6 w-full rounded-lg"
    });
function LazyReveal({ children , shimmer , rootMargin ="0px" , threshold =0.1 , className , onVisible , id , style  }) {
    const { 0: visible , 1: setVisible  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const observerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!wrapperRef.current) return;
        observerRef.current = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry.isIntersecting) {
                setVisible(true);
                onVisible && onVisible();
                observerRef.current?.disconnect();
            }
        }, {
            rootMargin,
            threshold
        });
        observerRef.current.observe(wrapperRef.current);
        return ()=>{
            observerRef.current?.disconnect();
        };
    }, [
        rootMargin,
        threshold
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: wrapperRef,
        className: className,
        id: id,
        style: style,
        children: visible ? children : shimmer || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DefaultShimmer, {})
    });
}


/***/ }),

/***/ 79782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21174);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useZipmeLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98196);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32866);
/* harmony import */ var _LazyReveal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70710);










const AccomplishSection = ({ eventData  })=>{
    const { zipmeLink , generateLink  } = (0,_hooks_useZipmeLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyReveal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().accomplishSection),
        style: {
            background: `linear-gradient(0deg, ${eventData?.accomplishSection?.sectionBgColorBottom || "#EEF2FB"} 50%, ${eventData?.accomplishSection?.sectionBgColorTop || "#ffffff"} 0)`
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().studentFooter),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().session),
                            style: {
                                backgroundColor: `${eventData?.accomplishSection?.sectionBgColor}`
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        style: {
                                            color: eventData?.titleTextColor || eventData?.accomplishSection?.sectionTitleColor || "#fff"
                                        },
                                        children: eventData?.accomplishSection?.sectionTitle
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().anchor),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            onClick: ()=>{
                                                !eventData?.meta?.jotforms[0]?.jotformid && generateLink(eventData?.externalLink);
                                            },
                                            className: `btn btn-primary   ${eventData?.meta?.jotforms[0]?.jotformid ? ` ${(0,_utils_helpers__WEBPACK_IMPORTED_MODULE_4__/* .isFrappeOrJotFormClass */ .gd)(eventData?.meta?.jotforms[0]?.jotformid)}` : ""}`,
                                            children: eventData.accomplishSection?.button?.label || "Register Now"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                                            dangerouslySetInnerHTML: {
                                                __html: `window.lintrk('track', { conversion_id: 6870956 });`
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AccomplishSection);


/***/ }),

/***/ 17057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21174);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31555);
/* harmony import */ var _VisibilitySensorComponent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54820);







const EduFairKcByNumber = ({ data  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "edu-fair-kcbynumber",
        className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3___default().kcByNumber),
        style: {
            background: data?.sectionBgColor || "#FFFFFF"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3___default().number),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3___default().heading),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: data?.coreTitle
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        children: data?.sections?.length > 0 && data?.sections.map((section)=>{
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                xl: 4,
                                lg: 4,
                                md: 4,
                                sm: 12,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3___default().box),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            style: {
                                                color: section?.color
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_VisibilitySensorComponent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                end: parseInt(section?.countText.replace(/[,+Cr]/g, "")),
                                                suffix: section?.countText.includes("Cr+") ? " Cr+" : section?.countText.includes("+") ? "+" : ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                            children: section?.sectionTitle
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: section?.sectionDesc
                                        })
                                    ]
                                })
                            });
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (EduFairKcByNumber);


/***/ }),

/***/ 17477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21174);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31555);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);







const WhyChoosKcStudyAbroad = ({ data  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "whychoos-kcstudyabroad",
        className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3___default().choosekc),
        style: {
            background: data?.sectionBgColor || "#ffffff"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3___default().whykc),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3___default().heading),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: data?.sectionTitle
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        children: data?.pointImage?.length > 0 && data?.pointImage.map((point)=>{
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                xl: 4,
                                lg: 4,
                                md: 4,
                                sm: 12,
                                xs: 6,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3___default().box),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3___default().img),
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                    src: point?.imageUrl,
                                                    width: 100,
                                                    height: 110,
                                                    alt: "Free Counselling"
                                                }),
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: point?.title
                                            })
                                        })
                                    ]
                                })
                            });
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (WhyChoosKcStudyAbroad);


/***/ }),

/***/ 54820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_VisibilitySensorComponent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/dist/visibility-sensor.js
var visibility_sensor = __webpack_require__(33082);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./node_modules/react-countup/build/index.js
var build = __webpack_require__(17857);
;// CONCATENATED MODULE: ./components/CountUp.tsx


const CountUpComp = (props)=>{
    const { end , suffix  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
        duration: 0.4,
        end: end,
        redraw: true,
        suffix: suffix || "",
        enableScrollSpy: true,
        separator: ","
    });
};
/* harmony default export */ var CountUp = (CountUpComp);

;// CONCATENATED MODULE: ./components/VisibilitySensorComponent.tsx



const VisibilitySensorComponent = (props)=>{
    const { end , suffix  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
            partialVisibility: true,
            offset: {
                bottom: 10,
                top: 10
            },
            children: ({ isVisible  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: isVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CountUp, {
                        end: end,
                        suffix: suffix
                    }) : end
                })
        })
    });
};
/* harmony default export */ var components_VisibilitySensorComponent = (VisibilitySensorComponent);


/***/ }),

/***/ 83157:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"countryadmissionsday_banner__kiMij","nav":"countryadmissionsday_nav__Stoca","navLogo":"countryadmissionsday_navLogo__9pU_M","maincontent":"countryadmissionsday_maincontent__EWEY_","fairdetails":"countryadmissionsday_fairdetails__Q9kXE","heading":"countryadmissionsday_heading__oUjWt","ulli":"countryadmissionsday_ulli__Mhf1j","regBtn":"countryadmissionsday_regBtn__Vf3yK","btnReg":"countryadmissionsday_btnReg__iT8q7","bannerStudDiv":"countryadmissionsday_bannerStudDiv__EQIjZ","bg":"countryadmissionsday_bg__RN8Zt","benefitsAttend":"countryadmissionsday_benefitsAttend__bvSoj","maindiv":"countryadmissionsday_maindiv__6v1if","mainBox":"countryadmissionsday_mainBox__Wl52Z","box":"countryadmissionsday_box__8dxaS","img":"countryadmissionsday_img__dv_xO","popularcourses":"countryadmissionsday_popularcourses__jyhHM","card":"countryadmissionsday_card__u19D_","cardImgDiv":"countryadmissionsday_cardImgDiv__CvCb0","cardImg":"countryadmissionsday_cardImg__rxXNr","cardBody":"countryadmissionsday_cardBody__DqTNl","caption":"countryadmissionsday_caption__p1FL9","caption2":"countryadmissionsday_caption2__0ZZIA","sliderDots":"countryadmissionsday_sliderDots__YKBHs","studentSpecialOffer":"countryadmissionsday_studentSpecialOffer__MJVJT","stuImg":"countryadmissionsday_stuImg__AXevw","whystuImg":"countryadmissionsday_whystuImg__yYoGk","stuImgtext":"countryadmissionsday_stuImgtext__7RB1a","stuImgtextd":"countryadmissionsday_stuImgtextd__y1nZx","headingabout":"countryadmissionsday_headingabout__UoSJC","OffersContent":"countryadmissionsday_OffersContent___hKfL","ulItem":"countryadmissionsday_ulItem__yRlU7","liItem":"countryadmissionsday_liItem__PuSD8","anchor":"countryadmissionsday_anchor__4W9FQ","row":"countryadmissionsday_row__i9im3","ScholarshipStudent":"countryadmissionsday_ScholarshipStudent__IaBcj","schStImg":"countryadmissionsday_schStImg__ykGre","SchContent":"countryadmissionsday_SchContent__49H1Q","studyquas":"countryadmissionsday_studyquas__EmUX3","stuAccordion":"countryadmissionsday_stuAccordion__VbaZm","accordion-button":"countryadmissionsday_accordion-button__Rh70t","collapsed":"countryadmissionsday_collapsed__J8CFE","accoHead":"countryadmissionsday_accoHead__tddyE","arrowsClass":"countryadmissionsday_arrowsClass__5cP_b","btcircle":"countryadmissionsday_btcircle__TCk9W","studentFooter":"countryadmissionsday_studentFooter__3qaYy","session":"countryadmissionsday_session__aK7h9","popularCoursesbg":"countryadmissionsday_popularCoursesbg__DA_qC","popularCourseslider":"countryadmissionsday_popularCourseslider__H3E7V","studyServSection":"countryadmissionsday_studyServSection__VYBux","imgPosition":"countryadmissionsday_imgPosition__CGsRP","txtPosition":"countryadmissionsday_txtPosition__HgE3L","studyContent":"countryadmissionsday_studyContent__q6tUY","studyContentpink":"countryadmissionsday_studyContentpink__WPJBO","platformDivImg":"countryadmissionsday_platformDivImg__R7aEn","picRound":"countryadmissionsday_picRound__DpvDp","pica":"countryadmissionsday_pica__XFIO9","picb":"countryadmissionsday_picb__Zztdr","picc":"countryadmissionsday_picc__Phr1j","picd":"countryadmissionsday_picd__gNom0","ulliQuick":"countryadmissionsday_ulliQuick__7OfrH","ulliQuickli":"countryadmissionsday_ulliQuickli__Aiptw","quickImg":"countryadmissionsday_quickImg__Yb4B_"};

/***/ })

}]);